import { get as getDealersAuth, remove as removeDealersAuth } from "../services/localStorage";
import {
  get as getClientAuth,
  remove as removeClientAuth,
} from "../../services/localStorage";
import { isDealerUser } from "./userTypes";
import {
  getDealerAvatarUrl,
  getDealerDisplayName,
  getDealerInitials,
} from "./dealerIdentity";
import clientStore from "../../store";
import { LOG_OUT as CLIENT_LOG_OUT } from "../../constant";
import { LOG_OUT as DEALERS_LOG_OUT } from "../constant";

function safeGet(getter) {
  try {
    return getter({ key: "auth" }) || {};
  } catch (e) {
    return {};
  }
}

function mergeDealerAuth(primary = {}, secondary = {}) {
  if (!primary?.token) return secondary?.token ? secondary : primary;
  if (!secondary?.token) return primary;
  const sameUser =
    !secondary?.id ||
    !primary?.id ||
    String(secondary.id) === String(primary.id);
  if (!sameUser) return primary;
  return {
    ...primary,
    image:
      getDealerAvatarUrl(secondary) ||
      getDealerAvatarUrl(primary) ||
      primary.image ||
      "",
    firstname:
      secondary.firstname ||
      secondary.first_name ||
      primary.firstname ||
      primary.first_name ||
      "",
    lastname:
      secondary.lastname ||
      secondary.last_name ||
      primary.lastname ||
      primary.last_name ||
      "",
  };
}

/**
 * Dealers portal is dealer-only — resolve the active dealer identity.
 * Prefers Redux, then dealers LS, and overlays avatar/name from main-site auth
 * when the same dealer uploaded a newer profile photo on home.
 */
export function resolvePortalIdentity(dealersReduxAuth) {
  const fromRedux =
    dealersReduxAuth && typeof dealersReduxAuth === "object"
      ? dealersReduxAuth
      : {};
  const fromDealersLs = safeGet(getDealersAuth);
  const fromClientLs = safeGet(getClientAuth);

  let dealersAuth = fromRedux.token
    ? mergeDealerAuth(fromRedux, fromDealersLs)
    : fromDealersLs;

  if (dealersAuth?.token && isDealerUser(fromClientLs)) {
    dealersAuth = mergeDealerAuth(dealersAuth, fromClientLs);
  }

  if (dealersAuth?.token && isDealerUser(dealersAuth)) {
    return {
      kind: "dealer",
      auth: dealersAuth,
      displayName: getDealerDisplayName(dealersAuth),
      initials: getDealerInitials(dealersAuth),
      avatarUrl: getDealerAvatarUrl(dealersAuth),
      roleLabel: "Dealer",
    };
  }

  return {
    kind: null,
    auth: null,
    displayName: "",
    initials: "",
    avatarUrl: "",
    roleLabel: "",
  };
}

/** Clear the main-site client session (used when logging out a synced dealer). */
export function clearClientPortalSession() {
  try {
    removeClientAuth({ key: "auth" });
  } catch (e) {
    /* ignore */
  }
}

/** Clear dealers portal session storage. */
export function clearDealerPortalSession() {
  try {
    removeDealersAuth({ key: "auth" });
  } catch (e) {
    /* ignore */
  }
}

/**
 * Sign out of the dealers portal and the mirrored home-login session.
 * Dashboard logout used to clear only the dealers store, then App.js
 * restored the dealer from ATP_localstorage_auth.
 */
export function logoutDealerPortal(dealersDispatch) {
  try {
    clientStore.store.dispatch({ type: CLIENT_LOG_OUT });
  } catch (e) {
    clearClientPortalSession();
  }
  if (typeof dealersDispatch === "function") {
    dealersDispatch({ type: DEALERS_LOG_OUT });
  }
  clearDealerPortalSession();
}
